import React from "react";

import generateGridMediaStyles from "./generateGridMediaStyles";


type JustifyContentTypes = "start" | "center" | "space-between" | "space-around" | "space-evenly";
type AlignItemsTypes = "stretch" | "center" | "start" | "end";


interface RowProps {
  as?: string | React.ElementType;
  wrap?: string | string[];
  reverse?: boolean | boolean[];
  space?: number | number[];
  justifyContent?: JustifyContentTypes | JustifyContentTypes[];
  alignItems?: AlignItemsTypes | AlignItemsTypes[];
  children: React.ReactNode;
  compact?: boolean;
  [key: string]: any;
}


export default function Row(props: RowProps) {

  const returnAlignItems = (val: AlignItemsTypes | AlignItemsTypes[]) => ({
    alignItems: val
  });

  const returnJustifyContent = (val: JustifyContentTypes | JustifyContentTypes[]) => ({
    justifyContent: val
  });

  const returnWrap = (val: boolean | boolean[]) => ({
    flexWrap: val ? "wrap" : "nowrap"
  });

  const returnReverse = (reverseProp: boolean | boolean[]) => ({
    flexDirection: reverseProp ? "row-reverse" : "row"
  });

  const returnColumnSpaces = (val: number | number[]) => ({
    marginLeft: `-${val}px !important`,
    marginRight: `-${val}px !important`,
    "> *": {
      paddingRight: `${val}px !important`,
      paddingLeft: `${val}px !important`
    }
  });

  const {
    as = "div",
    compact = false,
    justifyContent,
    wrap = false,
    alignItems,
    space = 0,
    reverse = false,
    children,
    ...otherProps
  } = props;

  const Tag = as;

  return (
    <Tag
      css={[
        {
          display: "flex",
          flexBasis: `${compact ? "auto" : "100%"}`
        },
        generateGridMediaStyles(reverse, returnReverse),
        generateGridMediaStyles(wrap, returnWrap),
        generateGridMediaStyles(alignItems, returnAlignItems),
        generateGridMediaStyles(justifyContent, returnJustifyContent),
        generateGridMediaStyles(space, returnColumnSpaces)
      ]}
      {...otherProps}>

      {children}

    </Tag>
  );
}
